import { Grid, Box, Typography } from '@mui/material';
import { GroupOutlined } from '@mui/icons-material';
import React, { } from 'react';
import InviteButton from "./invitations/InviteButton";

const UsersHeader: React.FC = () => {
    return (
        <Grid
            item
            xs={12}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <Box display="flex" gap={3} alignItems="center">
                {<GroupOutlined fontSize="large" />}
                <Typography
                    variant="h4"
                    lineHeight="123.5%"
                    fontSize="34px"
                    letterSpacing="0.25px"
                    fontWeight={400}
                >
                    Users
                </Typography>
            </Box>
            <InviteButton />
        </Grid >
    );
};

export default UsersHeader;

